import { Dispatch } from '@reduxjs/toolkit'

import { getTracksForMe as getTracksForMeApiCall } from '@/helpers/api/tracksApi'
import { createLatestRunGuard } from '@/helpers/createLatestRunGuard'
import { getEndOfWorkDay, getStartOfWorkDay } from '@/helpers/date'
import { getErrorResponse } from '@/helpers/getErrorResponse'
import {
    SET_LOADING,
    TRACKS_FAILURE,
    TRACKS_REQUEST,
    TRACKS_SUCCESS,
} from '@/redux/actionTypes'
import { Reducers } from '@/redux/reducers'

const startTracksRun = createLatestRunGuard()

export const getTracksForMe = () => async (dispatch: Dispatch, getState: () => Reducers): Promise<void> => {
    const isLatestRun = startTracksRun()

    dispatch({ type: SET_LOADING, loading: true })
    dispatch({ type: TRACKS_REQUEST })

    try {
        const includes = ['shift', 'shift.department', 'shift.department.group']

        const { selectedDays } = getState().calendarReducer
        const startDate = selectedDays[0]
        const endDate = selectedDays[selectedDays.length - 1]

        const response = await getTracksForMeApiCall(
            includes,
            getStartOfWorkDay(startDate),
            getEndOfWorkDay(endDate),
        )

        if (! isLatestRun()) return

        dispatch({
            type: TRACKS_SUCCESS,
            tracks: response.data,
        })
    } catch (error) {
        if (! isLatestRun()) return

        dispatch({ type: TRACKS_FAILURE, errors: [getErrorResponse(error)] })
    }

    dispatch({ type: SET_LOADING, loading: false })
}
